// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

import { token } from '@atlaskit/tokens';

import evaluateInner from './utils/evaluate-inner';

/* TODO body line height should be 1.25rem */
export default evaluateInner`

/* base styles */
#pendo-guide-container ._pendo-backdrop {
	background: ${token('color.blanket', '#091e427f')} !important;
}

#pendo-guide-container {
	background-color: ${token('elevation.surface.overlay', '#ffffff')} !important;
	box-shadow: ${token('elevation.shadow.overlay', '0px 0px 8px #091e4229, 0px 0px 1px #091e421f')} !important;
	border: ${token('color.border', '#091e4224')} !important;
	border-radius: ${token('border.radius', '3px')} !important;
}

#pendo-guide-container [id^='pendo-guide-data-text'] {
	color: ${token('color.text', '#172b4d')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--top,
#pendo-guide-container .pendo-tooltip-caret--top + .pendo-tooltip-caret-border {
	border-top-color: ${token('elevation.surface.overlay', '#ffffff')} !important;

}

#pendo-guide-container .pendo-tooltip-caret--right,
#pendo-guide-container .pendo-tooltip-caret--right + .pendo-tooltip-caret-border {
	border-right-color: ${token('elevation.surface.overlay', '#ffffff')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--bottom {
	border-bottom-color: ${token('elevation.surface.overlay', '#ffffff')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--left {
	border-left-color: ${token('elevation.surface.overlay', '#ffffff')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--top + .pendo-tooltip-caret-border {
	border-top-color: ${token('color.border', '#091e4224')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--right + .pendo-tooltip-caret-border {
	border-right-color: ${token('color.border', '#091e4224')} !important;

}

#pendo-guide-container .pendo-tooltip-caret--bottom + .pendo-tooltip-caret-border {
	border-bottom-color: ${token('color.border', '#091e4224')} !important;
}

#pendo-guide-container .pendo-tooltip-caret--left + .pendo-tooltip-caret-border {
	border-left-color: ${token('color.border', '#091e4224')} !important;
}

#pendo-guide-container ._pendo-text-paragraph,
#pendo-guide-container ._pendo-text-custom,
#pendo-guide-container ._pendo-text-subTitle,
#pendo-guide-container ._pendo-text-title,
#pendo-guide-container ._pendo-nps-open-text-poll-question {
	color: ${token('color.text', '#172b4d')} !important;


}

#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link,
#pendo-guide-container ._pendo-text-custom ._pendo-text-link,
#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link,
#pendo-guide-container ._pendo-text-title ._pendo-text-link {
	color: ${token('color.link', '#0052cc')} !important;

	/* Swapped out from 'none' */
	text-decoration: underline !important;
}

#pendo-guide-container ._pendo-button {
	border-radius: ${token('border.radius', '3px')} !important;
	font-weight: ${token('font.weight.medium', '500')} !important;
}

#pendo-guide-container ._pendo-button-primaryButton {
	background-color: ${token('color.background.brand.bold', '#0c66e4')} !important;
	color: ${token('color.text.inverse', '#fff')} !important;
}

#pendo-guide-container ._pendo-button-tertiaryButton,
#pendo-guide-container ._pendo-button-custom {
	background-color: ${token('color.background.neutral.subtle', '#00000000')} !important;
	color: ${token('color.text.subtle', '#44546f')} !important;
}

#pendo-guide-container div[class*='_pendo-number-scale-poll'] {
	color: ${token('color.text', '#172b4d')} !important;
}

#pendo-guide-container ._pendo-multi-choice-poll-select-border {
	background-color: transparent !important;
	border-width: ${token('border.width.0', '0px')} !important;
}

#pendo-guide-container ._pendo-multi-choice-poll-select {
	background-color: ${token('color.background.neutral', '#091e420f')} !important;
	cursor: pointer;
	color: ${token('color.text', '#42526e')} !important;
	box-sizing: border-box;
	border-radius: ${token('border.radius.100', '3px')} !important;
	/* ADS: Updated background, padding styles */
}

#pendo-guide-container [id^='pendo-radio-select-'] label.pendo-radio {
	color: ${token('color.text', '#172b4d')} !important;
	margin-top: 2px !important;
}

#pendo-guide-container ._pendo-open-text-poll-input {
	background-color: ${token('color.background.input', '#ffffff')} !important;
	border: 1px solid ${token('color.border.input', '#8590a2')} !important;
	border-radius: ${token('border.radius', '3px')} !important;
	color: ${token('color.text', '#091e42')} !important;
}

#pendo-guide-container [id^='pendo-radio-select'] input[type='radio'] {
	display: flex !important;
	width: ${token('space.300', '24px')} !important;
	height: ${token('space.300', '24px')} !important;
	margin: ${token('space.0', '0px')} !important;
	position: relative !important;
	-moz-box-align: center !important;
	align-items: center !important;
	-moz-box-pack: center !important;
	justify-content: center !important;
	flex-shrink: 0 !important;
	background-color: var(--radio-background-color);
	border: ${token('border.width', '1px')} solid var(--radio-border-color);
	border-radius: ${token('border.radius.circle', '50%')};
	outline: none;
	--radio-background-color: ${token('color.background.input', '#ffffff')};
	--radio-border-color: ${token('color.border.input', '#8590a2')};
	--radio-dot-color: ${token('color.icon.inverse', '#ffffff')} !important;

	--radio-dot-opacity: 0 !important;
	transform: scale(calc(0.583333)) !important;
	transition:
		border-color 0.2s ease-in-out,
		background-color 0.2s ease-in-out !important;
	vertical-align: top !important;
	appearance: none !important;
	-moz-appearance: none !important;
}

#pendo-guide-container ._pendo-required-indicator {
	color: ${token('color.text.danger', '#ae2e24')} !important;
	font-family: var(
		--ds-font-family-body,
		ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	) !important;
	padding-inline-start: ${token('space.025', '2px')} !important;
}

/* pseudo styles */

#pendo-guide-container
	*:focus-visible::-moz-focus-inner:not(
		.pendo-start-focus-bumper:focus-visible:-moz-focus-inner
			.pendo-end-focus-bumper:focus-visible:-moz-focus-inner
	) {
	border-radius: ${token('border.radius', '3px')} !important;
}

/* ADS: added ._pendo-multi-choice-poll-select-border */
#pendo-guide-container
	*:focus-visible:not(
		.pendo-start-focus-bumper:focus-visible,
		.pendo-end-focus-bumper:focus-visible,
		.pendo-radio:focus-visible,
		._pendo-open-text-poll-input:focus-visible,
		._pendo-close-guide:focus-visible,
		._pendo-multi-choice-poll-select-border
	) {
	/* ADS: Added outline-none */
	outline: none !important;
	outline-color: ${token('color.border.focused', '#388bff')} !important;
	outline-width: ${token('border.width.outline', '2px')} !important;
	outline-style: solid !important;
	outline-offset: ${token('space.025', '2px')} !important;
	border-radius: ${token('border.radius', '3px')} !important;
}

#pendo-guide-container ._pendo-close-guide:focus-visible {
	outline-offset: 0px !important;
}

#pendo-guide-container [id^='pendo-radio-select'] input[type='radio']:checked {
	--radio-background-color: ${token('color.background.selected.bold', '#0052cc')} !important;
	--radio-border-color: ${token('color.background.selected.bold', '#0052cc')} !important;
	--radio-dot-opacity: 1 !important;
}

#pendo-guide-container [id^='pendo-radio-select'] input[type='radio']::after {
	width: calc(6.85714px);
	height: calc(6.85714px);
	position: absolute;
	background: var(--radio-dot-color);
	border-radius: ${token('border.radius.circle', '50%')};
	content: '';
	opacity: var(--radio-dot-opacity);
	transition:
		background-color 0.2s ease-in-out,
		opacity 0.2s ease-in-out;
}

#pendo-guide-container .pendo-radio:focus-visible {
	outline: ${token('border.width.outline', '3px')} solid ${token('color.border.focused', '#2684FF')} !important;
	outline-offset: ${token('border.width.indicator', '3px')} !important;
}

#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:hover,
#pendo-guide-container ._pendo-text-custom ._pendo-text-link:hover,
#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:hover,
#pendo-guide-container ._pendo-text-title ._pendo-text-link:hover {
	color: ${token('color.link', '#0052cc')} !important;
	text-decoration: underline !important;
}

#pendo-guide-container ._pendo-button-primaryButton:hover {
	background-color: ${token('color.background.brand.bold.hovered', '#0055cc')} !important;
}

#pendo-guide-container ._pendo-button-secondaryButton:hover,
#pendo-guide-container ._pendo-button-tertiaryButton:hover,
#pendo-guide-container ._pendo-button-custom:hover {
	color: ${token('color.text.subtle', '#44546f')} !important;
	background-color: ${token('color.background.neutral.hovered', '#091e4224')} !important;
}

#pendo-guide-container ._pendo-button:disabled._pendo-button[disabled] {
	border-color: currentcolor !important;
	border-radius: ${token('border.radius.100', '3px')} !important;
	border-width: ${token('border.width.0', '0px')} !important;
	padding-inline-end: ${token('space.150', '12px')} !important;
	padding-inline-start: ${token('space.150', '12px')} !important;
	text-align: center !important;
	transition:
		background 0.1s ease-out,
		box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) !important;
	text-decoration: none !important;
	background-color: ${token('color.background.disabled', '#091e4208')} !important;
	color: ${token('color.text.disabled', '#091e424f')} !important;
	cursor: not-allowed !important;
	pointer-events: auto !important;
}

#pendo-guide-container ._pendo-open-text-poll-input::placeholder {
	color: ${token('color.text.subtlest', '#6b778c')} !important;
}

/* ------------------------------
* -- Your Custom Classes/IDs ----
------------------------------ */

/* Added styles */

/* Close button */
#pendo-guide-container ._pendo-close-guide {
	top: ${token('space.250', '20px')} !important;
	right: ${token('space.250', '20px')} !important;

	/* Button styles */
	color: ${token('color.icon', '#172b4d')} !important;
	width: 32px !important;
	height: 32px !important;
	border-radius: ${token('border.radius', '3px')} !important;
	cursor: pointer !important;
	transition: background 0.1s ease-out !important;

	/* Size "x" to 16px and appropriate weight, matching new icon styles */
	font-size: 30px !important;
	font-weight: 300 !important;

	/* Center "x" in button */
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
	padding-bottom: 5px !important;
}

#pendo-guide-container ._pendo-close-guide:hover {
	background-color: ${token('color.background.neutral.subtle.hovered', '#091e420f')} !important;
	color: ${token('color.icon', '#172b4d')} !important;
}

#pendo-guide-container ._pendo-close-guide:active {
	background-color: ${token('color.background.neutral.subtle.pressed', '#091e4224')} !important;
}

/* Rating buttons */
#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio {
	background-color: ${token('color.background.input', '#ffffff')} !important;
	border-width: ${token('border.width', '1px')} !important;
	border-style: solid !important;
	border-color: ${token('color.border.input', '#8590a2')} !important;
	color: ${token('color.text', '#172b4d')} !important;
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
}

#pendo-guide-container label[class*='_pendo-number-scale-poll'] {
	margin-right: 4px !important;
	margin-left: 0px !important;
}

#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:hover {
	background-color: ${token('color.background.input.hovered', '#f7f8f9')} !important;
}

#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:active {
	background-color: ${token('color.background.input.pressed', '#ffffff')} !important;
}

#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type='radio'].pendo-radio:checked + label {
	background-color: ${token('color.background.selected', '#cce0ff')} !important;
	color: ${token('color.text.selected', '#0c66e4')} !important;
	border-color: ${token('color.border.selected', '#0c66e4')} !important;
	border-width: 2px !important;
}

/* primary button */
#pendo-guide-container ._pendo-button-primaryButton._pendo-button:hover {
	background: ${token('color.background.brand.bold.hovered', '#0055cc')} !important;
}

#pendo-guide-container ._pendo-button-primaryButton._pendo-button:active {
	background: ${token('color.background.brand.bold.pressed', '#09326c')} !important;
}

/* secondary button, yes/no buttons*/
#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:hover,
#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button:hover,
#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:hover {
	background: ${token('color.background.neutral.hovered', '#091e4224')} !important;
}

#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:active
	._pendo-button._pendo-yes-no-poll-yes-button:active,
#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:active {
	background: ${token('color.background.neutral.pressed', '#091e424f')} !important;
}

/*	tertiary button */
#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:hover {
	background: ${token('color.background.neutral.subtle.hovered', '#091e420f')} !important;

}

#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:active {
	background: ${token('color.background.neutral.subtle.pressed', '#091e4224')} !important;
}

#pendo-guide-container h2 {
	font: var(
		--ds-font-heading-medium,
		normal 500 20px/24px ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	) !important;
	margin-bottom: ${token('space.100', '8px')} !important;
}
/* Pendo custom selctors */
#pendo-guide-container h3 {
	font: var(
		--ds-font-heading-small,
		normal 600 16px/20px ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	) !important;
	margin-top: 4px !important; /* Mostly necessary to allow user to click in WSYWIG editor, but adds some spacing */
	margin-bottom: ${token('space.100', '8px')} !important;
}

/* Form labels */
#pendo-guide-container ._pendo-text-paragraph._pendo-open-text-poll-question,
#pendo-guide-container ._pendo-text-paragraph._pendo-multi-choice-poll-question {
	padding-top: ${token('space.100', '4px')} !important;
	margin-bottom: ${token('space.050', '4px')}!important;
	font:
		normal 400 12px/16px ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif !important;
	color: ${token('color.text.subtle', '#44546f')} !important;
	font-weight: ${token('font.weight.semibold', '600')} !important;
}

#pendo-guide-container ._pendo-text-paragraph {
	font: var(
		--ds-font-body,
		normal 400 14px/20px ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	) !important;
}

/* Add gap between number scale descriptions and the items above them*/
#pendo-guide-container ._pendo-number-scale-poll-1-description,
#pendo-guide-container ._pendo-number-scale-poll-5-description {
	margin-top: ${token('space.050', '4px')} !important;
	color: ${token('color.text.subtle', '#44546f')} !important;

}

/* There was an odd bug where radios had black backgrounds */
#pendo-guide-container label.pendo-radio:hover,
#pendo-guide-container input[type='radio'].pendo-radio:checked + label {
	background-color: transparent !important;
}

/* Disable label focus ring for radios */
#pendo-guide-container ._pendo-multi-choice-poll-select-border input[type='radio'].pendo-radio:focus + label {
	outline: none !important;
}

/* Outline around NPS poll - */
#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type='radio'].pendo-radio:focus + label {
	outline-offset: 4px !important;
	outline-color: ${token('color.border.focused', '#388bff')} !important;
}

/* Modal padding */
#pendo-guide-container {
	padding: ${token('space.300', '24px')} !important;
}

/* Text field has outline as focus style */
#pendo-guide-container ._pendo-open-text-poll-input {
	font-family: var(
		--ds-font-family-body,
		ui-sans-serif,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Ubuntu,
		system-ui,
		'Helvetica Neue',
		sans-serif
	) !important;
	transition:
		background-color 0.2s ease-in-out 0s,
		border-color 0.2s ease-in-out 0s;
	margin-block: 0px !important;
}

#pendo-guide-container ._pendo-open-text-poll-input:focus-visible {
	outline: none !important;
	box-shadow: inset 0 0 0 ${token('border.width', '1px')} ${token('color.border.focused', '#2684ff')} !important;
	border-color: ${token('color.border.focused', '#2684ff')} !important;
}

/* Hover state for text poll input */
#pendo-guide-container ._pendo-open-text-poll-input:hover {
	background-color: ${token('color.background.input.hovered', '#f7f8f9')} !important;
}

/* Select styles */
#pendo-guide-container ._pendo-multi-choice-poll-select {
	background: ${token('color.background.input', '#ffffff')} !important;
	border-width: ${token('border.width', '1px')} !important;
	border: solid ${token('color.border.input', '#8590a2')} !important;
	padding-inline: ${token('space.075', '6px')} !important;
	padding-block: ${token('space.025', '2px')} !important;

	transition:
		background-color 200ms ease-in-out 0s,
		border-color 200ms ease-in-out 0s !important;
}

#pendo-guide-container ._pendo-multi-choice-poll-select:hover {
	background-color: ${token('color.background.input.hovered', '#f7f8f9')} !important;
}

#pendo-guide-container ._pendo-multi-choice-poll-select:active {
	background-color: ${token('color.background.input.pressed', '#ffffff')} !important;
}

/* Guide container */
#pendo-guide-container hr {
	border-color: ${token('color.border', '#091e4224')} !important;
	margin-block: ${token('space.100', '8px')} !important;
	border-width: ${token('border.width', '1px')} 0 0 !important;
}

/* Pendo button styles */
#pendo-guide-container ._pendo-button {
	transition: background 0.1s ease-out 0s !important;
	height: ${token('space.400', '32px')} !important;
	font-weight: 500 !important;
	padding-inline: ${token('space.150', '12px')} !important;
	padding-block: 0px !important;
	cursor: pointer !important;
}
#pendo-guide-container ._pendo_button:hover,
#pendo-guide-container ._pendo_button:active {
	transition-duration: 0s !important;
}

/* Secondary buttons */
#pendo-guide-container ._pendo-button-secondaryButton,
#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button,
#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button {
	background-color: ${token('color.background.neutral', '#091e420f')} !important;
	color: ${token('color.text', '#172b4d')} !important;
}

/* Link pressed styles */
#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:active,
#pendo-guide-container ._pendo-text-custom ._pendo-text-link:active,
#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:active,
#pendo-guide-container ._pendo-text-title ._pendo-text-link:active {
	color: ${token('color.link.pressed', '#0055cc')} !important;
}
`;
